import { render, staticRenderFns } from "./back.vue?vue&type=template&id=2c904b16&scoped=true"
import script from "./back.vue?vue&type=script&lang=js"
export * from "./back.vue?vue&type=script&lang=js"
import style0 from "./back.vue?vue&type=style&index=0&id=2c904b16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c904b16",
  null
  
)

export default component.exports